// Colors are kept in-app rather than added to core since this is an experiment
// and we're not sure if this feature will live. We want to roll out fast.
export const GUARANTEED_PAY_BANNER_GRADIENT = "linear-gradient(to bottom, #F1EBAB, #FFDCA4)";
export const GUARANTEED_PAY_BOTTOM_SHEET_GRADIENT = "linear-gradient(to bottom, #FFFDEF, #FFEDCF)";

export const GUARANTEED_PAY_WAITLIST_LOCAL_STORAGE_KEY_PREFIX = "guaranteed-pay-waitlist-response";

export const GUARANTEED_PAY_WAITLIST_RESPONSES = {
  INTERESTED: "INTERESTED",
  NOT_INTERESTED: "NOT_INTERESTED",
} as const;

export type GuaranteedPayWaitlistResponse =
  (typeof GUARANTEED_PAY_WAITLIST_RESPONSES)[keyof typeof GUARANTEED_PAY_WAITLIST_RESPONSES];

export function getGuaranteedPayWaitlistStorageKey(workerId: string): string {
  return `${GUARANTEED_PAY_WAITLIST_LOCAL_STORAGE_KEY_PREFIX}-${workerId}`;
}
